import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { List } from 'immutable';
import { IJobFileListData } from './job-file-list.data';

@Component({
  selector: 'i2g-job-file-list',
  templateUrl: './job-file-list.component.html',
  styleUrls: ['./job-file-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobFileListComponent implements OnInit {
  @Input() showDeleteButton: boolean;
  @Input() fileListLabel: string;
  @Input() listItems: List<IJobFileListData>;

  constructor() {}

  ngOnInit() {}
}
